<mat-sidenav-container class="example-container">
  <mat-sidenav mode="side" opened>
    <side-menu></side-menu>
  </mat-sidenav>
  <mat-sidenav-content class="example-container-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
